import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { formOptions } from "@/data/site";

export const steps = [
  { key: "attivita", label: "La tua attività", title: "La tua attività", sub: "Ci serve per capire come aiutarti al meglio, non per valutarti." },
  { key: "interessi", label: "Interessi", title: "Cosa vuoi costruire", sub: "Qualche dettaglio per capire come aiutarti." },
  { key: "chi", label: "Chi sei", title: "Presentati", sub: "Ultimo passo: come possiamo ricontattarti." },
];

export const Field = ({ label, children }) => (
  <div>
    <label className="block font-sans-ui text-[10px] tracking-mega text-ink/50 mb-2">{label}</label>
    {children}
  </div>
);

export const inputCls =
  "w-full bg-transparent border-b hairline py-3 font-sans-ui text-sm text-ink placeholder:text-ink/30 focus:border-ink focus:outline-none transition-colors";

const Choice = ({ selected, onClick, children, testid }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className={`text-left font-sans-ui text-[13px] px-4 py-2.5 min-h-[44px] border transition-colors duration-200 ${
      selected ? "bg-ink text-ivory border-ink" : "hairline text-ink/70 hover:border-ink"
    }`}
  >
    {children}
  </button>
);

const Choices = ({ options, value, onPick, multi, prefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((c) => (
      <Choice
        key={c}
        testid={`${prefix}-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        selected={multi ? value.includes(c) : value === c}
        onClick={() => onPick(c)}
      >
        {c}
      </Choice>
    ))}
  </div>
);

export const StepChi = ({ form, set }) => (
  <>
    <div className="grid sm:grid-cols-2 gap-6">
      <Field label="NOME E COGNOME *">
        <input data-testid="lead-form-input-name" className={`${inputCls} min-h-[44px]`} value={form.full_name} onChange={(e) => set("full_name", e.target.value)} placeholder="Mario Rossi" />
      </Field>
      <Field label="NOME DEL BRAND / ATTIVITÀ *">
        <input data-testid="lead-form-input-brand" className={`${inputCls} min-h-[44px]`} value={form.brand_name} onChange={(e) => set("brand_name", e.target.value)} placeholder="Il tuo brand" />
      </Field>
      <Field label="EMAIL *">
        <input data-testid="lead-form-input-email" type="email" className={`${inputCls} min-h-[44px]`} value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="nome@email.com" />
      </Field>
    </div>
    <Field label="PAESE *">
      <Choices prefix="country" options={formOptions.countries} value={form.country} onPick={(c) => set("country", c)} />
    </Field>
    <Field label="WHATSAPP (OPZIONALE)">
      <p className="font-sans-ui text-[12px] text-ink/55 mb-1">Vuoi essere ricontattato anche su WhatsApp per una risposta più rapida?</p>
      <input data-testid="lead-form-input-phone" type="tel" className={`${inputCls} min-h-[44px]`} value={form.whatsapp} onChange={(e) => set("whatsapp", e.target.value)} placeholder="+39 ..." />
    </Field>
    <button type="button" data-testid="lead-form-gdpr" onClick={() => set("gdpr_consent", !form.gdpr_consent)} className="flex items-start gap-3 text-left">
      <span className={`mt-0.5 w-5 h-5 shrink-0 border flex items-center justify-center transition-colors ${form.gdpr_consent ? "bg-ink border-ink" : "hairline"}`}>
        {form.gdpr_consent && <Check size={13} className="text-ivory" />}
      </span>
      <span className="font-sans-ui text-[12px] text-ink/65 leading-relaxed">
        Accetto che My Brand Online utilizzi i dati forniti per ricontattarmi in merito alla mia richiesta, come descritto nella{" "}
        <Link to="/privacy" target="_blank" className="underline underline-offset-2 hover:text-ink" onClick={(e) => e.stopPropagation()}>Privacy Policy</Link>.
      </span>
    </button>
  </>
);

export const StepAttivita = ({ form, set }) => (
  <>
    <p data-testid="lead-form-value-copy" className="font-sans-ui text-[13px] text-ink/60 leading-relaxed italic -mt-2">
      Rispondendo a queste domande ti mostriamo come funzionerebbe My Brand Online per la tua attività, con un esempio di margine sul tuo caso specifico.
    </p>
    <Field label="HAI GIÀ UN'ATTIVITÀ FASHION?">
      <Choices prefix="business" options={formOptions.businessType} value={form.business_type} onPick={(c) => set("business_type", c)} />
    </Field>
    <Field label="DOVE VENDI ATTUALMENTE?">
      <Choices prefix="platform" options={formOptions.platform} value={form.selling_platform} onPick={(c) => set("selling_platform", c)} />
    </Field>
    <Field label="QUANTI ORDINI FAI MEDIAMENTE AL MESE?">
      <Choices prefix="orders" options={formOptions.orders} value={form.monthly_orders} onPick={(c) => set("monthly_orders", c)} />
    </Field>
  </>
);

export const StepInteressi = ({ form, set, toggleInterest }) => (
  <>
    <Field label="COSA TI INTERESSA MAGGIORMENTE?">
      <Choices prefix="interest" multi options={formOptions.interests} value={form.interests} onPick={toggleInterest} />
    </Field>
    <Field label="RACCONTACI BREVEMENTE COSA VUOI CREARE (OPZIONALE)">
      <textarea data-testid="lead-form-message" rows={3} className={`${inputCls} resize-none`} value={form.message} onChange={(e) => set("message", e.target.value)} placeholder="Il tuo progetto..." />
    </Field>
  </>
);
